import { render } from "./VartaSilver.vue?vue&type=template&id=21643a74&scoped=true&class=banner"
import script from "./VartaSilver.vue?vue&type=script&lang=js"
export * from "./VartaSilver.vue?vue&type=script&lang=js"

import "./VartaSilver.vue?vue&type=style&index=0&id=21643a74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21643a74"]])

export default __exports__